import { MaterialSubType } from "./MaterialSubType";
import { MaterialType } from "./MaterialType";

export class Material {

    private _MaterialType: MaterialType;
    public get MaterialType(): MaterialType {
        return this._MaterialType;
    }
    public set MaterialType(v: MaterialType) {
        this._MaterialType = v;
    }

    private _MaterialSubType: MaterialSubType;
    public get MaterialSubType(): MaterialSubType {
        return this._MaterialSubType;
    }
    public set MaterialSubType(v: MaterialSubType) {
        this._MaterialSubType = v;
    }

    constructor(materialType: MaterialType, materialSubtype: MaterialSubType) {
        this.MaterialType = materialType;
        this.MaterialSubType = materialSubtype;
    }

}